module.exports = __webpack_public_path__ + "img/error-page.8e3454c0.svg";